/**
 * Created by Allan on 2022/08/03.
 * Contact 84880528@qq.com.
 * 全局化过滤器
 * 您还可以在组件定义时的 filters 属性中按需引入
 */
import Vue from 'vue'
import txtDefault from './module/txtDefault';  //文字格式化

Vue.filter('txtDefault',txtDefault)



// WEBPACK FOOTER //
// ./src/smspromo/filter/index.js